<template>
  <div :class="{ 'dh-psy-data-viz': true,'dh-psy-data-viz--no-margin': noMargin, 'dh-psy-data-viz--small': small }">
    <div :class="{
      'dh-psy-data-viz__wrapper': true,
      'dh-psy-data-viz__wrapper--left': align === 'left',
      'dh-psy-data-viz__wrapper--right': align === 'right'
    }">
      <ImportedIllustration :id="id" />
    </div>
    <DataVizDescription v-if="description" :align="align" :description="description" />
  </div>
</template>

<script>
import ImportedIllustration from './illustration.vue'
import DataVizDescription from './description.vue'

export default {
  props: ['item'],
  computed: {
    id() {
      return this.item.value.id
    },
    description() {
      return this.item.value.description
    },
    align() {
      return this.item.value.align
    },
    noMargin() {
      return this.item.value['no-margin']
    },
    small() {
      return this.item.value['size'] === 'small'
    }
  },
  components: {
    ImportedIllustration,
    DataVizDescription
  }
}
</script>

<style lang="postcss" scoped>
  .dh-psy-data-viz {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;

    &.dh-psy-data-viz--no-margin {
      padding: 0;
    }

    &.dh-psy-data-viz--small {
      margin: 0 auto;
      max-width: 364px;

      @media (min-width: 800px) {
        &.dh-psy-data-viz--no-margin {
          margin: 0 auto;
        }
      }
    }

    @media (min-width: 800px) {
      margin: 150px auto;
      justify-content: space-between;

      &.dh-psy-data-viz--no-margin {
        margin: 50px auto;
      }
    }
  }

  .dh-psy-data-viz__wrapper {
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;

    @media (min-width: 800px) {
      width: 750px;

      &.dh-psy-data-viz__wrapper--left,
      &.dh-psy-data-viz__wrapper--right {
        width: 50%;
        max-width: 590px;
      }
    }
  }

  .dh-psy-data-viz__wrapper--left {
  }
  .dh-psy-data-viz__wrapper--right {
    @media (min-width: 800px) {
      order: 2;
    }
  }
</style>
